__turbopack_context__.v({
  "accordion": "NavMenu-module__fGo4wG__accordion",
  "closedAccordion": "NavMenu-module__fGo4wG__closedAccordion",
  "footerEnabled": "NavMenu-module__fGo4wG__footerEnabled",
  "modalHeader": "NavMenu-module__fGo4wG__modalHeader",
  "modalHeight": "NavMenu-module__fGo4wG__modalHeight",
  "redirectUrl": "NavMenu-module__fGo4wG__redirectUrl",
  "subNavList": "NavMenu-module__fGo4wG__subNavList",
  "titleWithIcon": "NavMenu-module__fGo4wG__titleWithIcon",
});
